// components/Address/AddressInputGroup.js
import React from 'react';
import { Grid } from '@mui/material';
import AddressField from './AddressField';
import SubLabelField from './SubLabelField';

const AddressInputGroup = ({
  mainValue,
  onMainChange,
  mainError,
  subValue,
  onSubChange,
  readOnly,
  isReadOnly,
  condition,
  headingColor,
  handleHeadingFocus
}) => (
  <Grid pb={'24px'}>
    <AddressField
      value={mainValue}
      onChange={onMainChange}
      error={mainError}
      // readOnly={!isReadOnly}
      headingColor={headingColor}
    />
    <SubLabelField
      value={subValue}
      onChange={onSubChange}
      readOnly={condition}
      isReadOnly={isReadOnly}
      handleHeadingFocus={handleHeadingFocus}
    />
  </Grid>
);

export default AddressInputGroup;
